import { Integration, IntegrationCreate, IntegrationListResponse, IntegrationUpdate } from '@kibsi/ks-tenant-types'
import { AxiosRequestConfig } from 'axios'
import { KibsiClient } from './base'
import { KibsiClientParams } from './params'

const SERVICE = 'tenant'

export class IntegrationKibsiClient extends KibsiClient {
    constructor(params: KibsiClientParams) {
        super(params, SERVICE)
    }

    list(requestConfig?: AxiosRequestConfig): Promise<IntegrationListResponse> {
        return this.get(`/integrations`, requestConfig)
    }

    read(entityId: string, requestConfig?: AxiosRequestConfig): Promise<Integration> {
        return this.get(`/integrations/${entityId}`, requestConfig)
    }

    create(entity: IntegrationCreate, requestConfig?: AxiosRequestConfig): Promise<Integration> {
        return this.post('/integrations', entity, requestConfig)
    }

    update(entity: IntegrationUpdate, requestConfig?: AxiosRequestConfig): Promise<void> {
        return this.put(`/integrations/${entity.integrationId}`, entity, requestConfig)
    }

    delete(entityId: string, requestConfig?: AxiosRequestConfig): Promise<void> {
        return this.del(`/integrations/${entityId}`, requestConfig)
    }
}
